import { render, staticRenderFns } from "./CargoSerieComponent.vue?vue&type=template&id=74504ecd&"
import script from "./CargoSerieComponent.vue?vue&type=script&lang=js&"
export * from "./CargoSerieComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports